import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-pads-tranings',
  templateUrl: './e-pads-tranings.component.html',
  styleUrls: ['./e-pads-tranings.component.scss']
})
export class EPadsTraningsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
